/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import jobStyles from "./jobStyles";
import SendApplication from "./SendApplication";
import TextContainer from "../../Container/TextContainer";
import { Helmet } from "react-helmet-async";
import Layout from "../../../containers/Layouts/Layout";
import Typography from "@mui/material/Typography";
import HeadlineSection from "../../Sections/Generic/HeadlineSection/HeadlineSection";
import cvImage from "../../../assets/img/jobs/cv.svg";
import { Box } from "@mui/material";
import MuiListNativeStyled from "../../List/MuiListNativeStyled";
import { gaSet } from "../../../services/googleAnalyticsService";

const LegalTrainee = () => {
  const title = "Jobs - Rechtsreferendarin / Rechtsreferendar | Legalbird";

  gaSet({ title: title });

  return (
    <Layout backgroundType={"landingpage"}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <HeadlineSection headline={"Rechtsreferendarin / Rechtsreferendar (m/w/d)"} image={cvImage} />
      <TextContainer sx={jobStyles.container}>
        <Typography variant={"h4"} sx={{
          textAlign: "center"
        }}>
          für die Anwalts- oder Wahlstation
        </Typography>
        <Typography sx={{
          marginBottom: "16px"
        }}>
          Legalbird Rechtsanwälte Rechtsanwalts GmbH - als Partnerkanzlei von Legalbird helfen wir unseren Mandanten einfach und effizient.
        </Typography>
        <Typography sx={{
          marginBottom: "16px"
        }}>
          Durch unsere Expertise in den Bereichen Familienrecht, Verkehrsrecht, Vertragsrecht, Mietrecht und Arbeitsrecht und den Einsatz neuester Technologie,
          helfen wir unseren Mandanten, ihre rechtlichen Fragestellungen sicher und schnell online zu lösen.
        </Typography>
        <Box>
          <Typography variant={"h4"}>Was Deine Aufgaben sein werden</Typography>
          <MuiListNativeStyled
            sx={jobStyles.list}
            listItems={[
              "Du übernimmst die Vorprüfung von neu eingehenden Mandaten im Vertragsrecht",
              "Du erstellst außergerichtliche und gerichtliche Schrift sätze im Vertragsrecht",
              "Du stehst in direktem Kontakt mit den Mandanten",
              "Du unterstützt bei der Konzeption und Ausarbeitung von Prozessen und neuen Rechtsbereichen für die Kanzlei und die Kooperation mit Legalbird",
            ]}
          />
          <Typography variant={"h4"}>Was Du dazu brauchst</Typography>
          <MuiListNativeStyled
            sx={jobStyles.list}
            listItems={[
              "Du hast das 1. Staatsexamen erfolgreich absolviert und suchst nun eine Herausforderung für deine Anwalts- oder Wahlstation",
              "Du denkst unternehmerisch und handelst pragmatisch, um für Deine Mandanten immer die bestmögliche Lösung zu finden",
              "Dich begeistert die Idee, Privatpersonen und Verbrauchern zu ihrem Recht zu verhelfen",
              "Du bist technologiebegeistert und arbeitest gerne und sehr versiert am PC und mit modernster Software",
            ]}
          />
          <Typography variant={"h4"}>Was wir Dir bieten und was uns auszeichnet</Typography>
          <MuiListNativeStyled
            sx={jobStyles.list}
            listItems={[
              "Einen flexiblen Arbeitsort vorwiegend mobil im Homeoffice mit Einarbeitung in unserem modernen Büro im Kranhaus im Kölner Rheinauhafen",
              "Eine überdurchschnittliche Vergütung",
              "Eine unternehmerische und anspruchsvolle Arbeit in einem motivierten und jungen Team",
              "Wir entscheiden und arbeiten sehr modern, automatisiert und mit vollem Fokus auf unsere Mandanten, um für diese das beste Ergebnis zu erzielen und ein ideales Kundenerlebnis zu bieten",
            ]}
          />
        </Box>
      </TextContainer>
      <SendApplication />
    </Layout>
  );
};

export default LegalTrainee;
